<span>
    <app-text-search-field [label]="label" [placeholder]="placeholder" [textSearchPattern]="textSearchPatternOrItemList.SearchPattern"></app-text-search-field>
    &nbsp;&nbsp;
    <mat-form-field appearance="outline">
        <mat-label>Search Type</mat-label>
        <mat-select [(ngModel)]="selectedSearchType" (change)="onSearchTypeChange($event.target)">
            <mat-option *ngFor="let searchType of searchTypes" [value]="searchType">{{ searchType.Name }}</mat-option>
        </mat-select>
    </mat-form-field>
</span>
